import '@emotion/react'
import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'
import { generatePadding } from '@lacedltd/laced-components'

export const Container = styled.div({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
})

export const Bubble = styled.span({
  boxSizing: 'border-box',
  background: tokens.color.airJordan.p,
  borderRadius: '50%',
  color: tokens.color.yeezy.p,
  fontSize: tokens.fontSize[1],
  whiteSpace: 'nowrap',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: generatePadding(0, 'spacing.2'),
  textAlign: 'center',
  height: '1.25rem',
  minWidth: '1.25rem',
  position: 'absolute',
  left: 'calc(100% - 0.813rem)',
  top: '-0.313rem',
  border: `0.104rem solid ${tokens.color.yeezy.p}`,
  pointerEvents: 'none',

  span: {
    color: tokens.color.yeezy[0]
  }
})
